export default __webpack_public_path__ + "static/media/thales-logo-white.85323757.svg";